import axios from 'axios'

const alertsRoute = '/api/rest/common/alerts'
const alertsCountRoute = `${alertsRoute}/count`

let cachedPage, cachedPageSize
export default {
  async getAlerts(page = 0, pageSize = 6) {
    cachedPage = page
    cachedPageSize = pageSize

    const first = page * pageSize
    const last = first + pageSize - 1

    try {
      const alertsResponse = await axios.get(alertsRoute, {
        headers: {
          Range: `items=${first}-${last}`,
        },
      })
      const countResponse = await axios.get(alertsCountRoute)

      const { unreadAlertCount, alertCount } = countResponse.data
      const list = alertsResponse.data

      return {
        page,
        list,
        unreadCount: unreadAlertCount,
        totalCount: alertCount,
      }
    } catch (error) {
      throw new Error(error.response.data.errorMessage)
    }
  },

  async markAlertRead(alertId) {
    try {
      await axios.put(`${alertsRoute}/${alertId}`, {
        state: 'r',
        user: '2', // FIXME: the user param is needed for a poorly designed API. the backend will fix this for v11 so it's ok to just pass this for now (http://jira/browse/NGUI-112)
      })

      return this.getAlerts(cachedPage, cachedPageSize)
    } catch (error) {
      throw new Error(error.response.data.errorMessage)
    }
  },

  async clearAlert(alertId) {
    try {
      await axios.delete(`${alertsRoute}/${alertId}`)
      return this.getAlerts(cachedPage, cachedPageSize)
    } catch (error) {
      throw new Error(error.response.data.errorMessage)
    }
  },

  async clearAllAlerts() {
    try {
      await axios.delete(alertsRoute)
      return this.getAlerts(cachedPage, cachedPageSize)
    } catch (error) {
      throw new Error(error.response.data.errorMessage)
    }
  },
}
